import { __decorate, __metadata } from "tslib";
import { ContainerValidationState } from '../ValidationState';
import { ValidationDisplayMode } from '../Misc';
import { ValidationDisplayInfo } from '../DisplayHelper';
import { Observable, Computed } from '../../Model/Decorators';
import { NeoTypeInfo } from '../../Model/NeoTypeInfo';
var PropertyValidator = /** @class */ (function () {
    function PropertyValidator(propertyInstance, ruleList) {
        this.propertyInstance = propertyInstance;
        this.ruleList = ruleList;
        /** True if an element bound to this property has lost focus. Used for displaying rules. */
        this.hasBlurred = false;
        NeoTypeInfo.makeObservable(this);
    }
    Object.defineProperty(PropertyValidator.prototype, "ruleState", {
        get: function () {
            this.checkRules();
            return this._ruleState;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PropertyValidator.prototype, "isValid", {
        get: function () {
            return this.ruleState.isValid;
        },
        enumerable: false,
        configurable: true
    });
    PropertyValidator.prototype.checkRules = function () {
        this._ruleState = new ContainerValidationState();
        if (this.ruleList) {
            for (var i = 0; i < this.ruleList.length; i++) {
                this._ruleState.merge(this.ruleList[i].ruleContext);
            }
        }
    };
    /** Infomation about the errors that must be shown on the UI. Independent from whether or not the property is valid. */
    PropertyValidator.prototype.getDisplayState = function (validationMode) {
        if (validationMode === ValidationDisplayMode.Never) {
            return new ValidationDisplayInfo();
        }
        else {
            return this.ruleState.getDisplayInfo(this.canDisplayAll(validationMode));
        }
    };
    /** True if the validation state is final, e.g. the property has blurred, or validation display mode is always. */
    PropertyValidator.prototype.canDisplayAll = function (validationMode) {
        return (validationMode == ValidationDisplayMode.Always ||
            this.propertyInstance.attachedTo.validator.forceShowErrors ||
            (validationMode == ValidationDisplayMode.AfterBlur && this.hasBlurred));
    };
    __decorate([
        Observable(),
        __metadata("design:type", Object)
    ], PropertyValidator.prototype, "hasBlurred", void 0);
    __decorate([
        Computed(),
        __metadata("design:type", ContainerValidationState),
        __metadata("design:paramtypes", [])
    ], PropertyValidator.prototype, "ruleState", null);
    return PropertyValidator;
}());
export default PropertyValidator;
